export const colors = {
  PRIMARY: "#1974FC",
  WHITE: "white",
  GREEN: "#1ACB76",
  YELLOW: "#FEB700",
  RED: "#FC1942",
  DARK: "#112737",
};
